module.exports = (__webpack_public_path__ || '') + "static/images/favicon-16x16-12b62e413e7f06065a10be86711ccc29.png";